module.exports = __webpack_public_path__ + "img/warning.632605e5.png";